import { render, staticRenderFns } from "./FinanceAccountManage.vue?vue&type=template&id=5c63c517&scoped=true"
import script from "./FinanceAccountManage.vue?vue&type=script&lang=js"
export * from "./FinanceAccountManage.vue?vue&type=script&lang=js"
import style0 from "./FinanceAccountManage.vue?vue&type=style&index=0&id=5c63c517&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c63c517",
  null
  
)

export default component.exports